import {Component, OnInit} from "@angular/core";
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {UserService} from "../../../shared/services/api_v1/user.service";

@Component({
    // moduleId: module.id,
    selector:'home-forgotpassword-form',
    templateUrl: './home-forgotpassword-form.component.html'
})
export class HomeForgotpasswordComponent implements OnInit{
    form: FormGroup;

    email_invalid= false;
    submitted = false;
    button_disabled = false;

    constructor(private userService:UserService){}

    ngOnInit() {
        this.form = new FormGroup({
            email: new FormControl('',[ Validators.required ])
        });
    }

    forgot_password(): void {
        if(this.form.invalid){ return; }
        this.submitted = false;
        this.button_disabled = true;

        this.userService.forgot_password(
            this.form.get('email').value
        )
            .then(() => {
                this.submitted = true;
                this.email_invalid = false;
                this.button_disabled = false;
            })
            .catch(error => {
                this.submitted = true;
                this.email_invalid = true;
                this.button_disabled = false;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/front/home/forgotpassword/home-forgotpassword-form.component.ts